import moment from "moment";

const Item = ({ total_points, user, created_at, cart_box_size }) => {
  return (
    <li className="dashboard__list-item">
      <div className="m-r-15">
        <p>Data utworzenia: {moment(created_at).format("DD-MM-YYYY HH:mm")}</p>
        <p>
          Użytkownik: {user?.first_name} {user?.last_name}
        </p>
        <p>Ilość punktów: {parseFloat(total_points).toFixed(2)}</p>
        {cart_box_size && <p>Rozmiar zamówienia: {cart_box_size}</p>}
      </div>
    </li>
  );
};

export default Item;
